import { getOrderStatusEmailTemplate } from '@/emails/orderStatusTemplates';

export const STORAGE_KEY = 'email_templates';

// Get a template - always use default template since we're server-side
export const getTemplate = (templateId: string, orderData: any): string => {
  try {
    console.log(`Getting email template for status: ${templateId}`);
    const template = getOrderStatusEmailTemplate(templateId, orderData);
    
    if (!template) {
      console.error(`No template found for status: ${templateId}`);
      return '';
    }
    
    console.log(`Template generated successfully for status: ${templateId}`);
    return template;
  } catch (error) {
    console.error('Error getting template:', error);
    return ''; // Return empty string as a last resort
  }
};

// Save a custom template
export const saveTemplate = (templateId: string, content: string): boolean => {
  try {
    // Check if localStorage is available
    if (typeof window === 'undefined' || !window.localStorage) {
      console.warn('localStorage not available, cannot save template');
      return false;
    }
    
    // Get existing templates
    const storedTemplates = localStorage.getItem(STORAGE_KEY);
    const templates = storedTemplates ? JSON.parse(storedTemplates) : {};
    
    // Update with new template
    templates[templateId] = content;
    
    // Save back to localStorage
    localStorage.setItem(STORAGE_KEY, JSON.stringify(templates));
    return true;
  } catch (error) {
    console.error('Error saving template:', error);
    return false;
  }
};

// Delete a custom template
export const deleteTemplate = (templateId: string): boolean => {
  try {
    // Check if localStorage is available
    if (typeof window === 'undefined' || !window.localStorage) {
      console.warn('localStorage not available, cannot delete template');
      return false;
    }
    
    // Get existing templates
    const storedTemplates = localStorage.getItem(STORAGE_KEY);
    if (!storedTemplates) return true; // Nothing to delete
    
    const templates = JSON.parse(storedTemplates);
    
    // If template doesn't exist, just return
    if (!templates[templateId]) return true;
    
    // Delete the template
    delete templates[templateId];
    
    // Save back to localStorage
    localStorage.setItem(STORAGE_KEY, JSON.stringify(templates));
    return true;
  } catch (error) {
    console.error('Error deleting template:', error);
    return false;
  }
};

// Get all template IDs
export const getAllTemplates = (): Record<string, string> => {
  try {
    // Check if localStorage is available (important for SSR or tests)
    if (typeof window === 'undefined' || !window.localStorage) {
      console.warn('localStorage not available');
      return {};
    }
    
    const storedTemplates = localStorage.getItem(STORAGE_KEY);
    return storedTemplates ? JSON.parse(storedTemplates) : {};
  } catch (error) {
    console.error('Error getting all templates:', error);
    return {};
  }
}; 